/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "an-dè",
        "-2": "a-bhòin-dè",
        "0": "an-diugh",
        "1": "a-màireach",
        "2": "an-earar",
        "3": "an-eararais",
        "future": {
          "few": "an ceann {0} làithean",
          "one": "an ceann {0} latha",
          "other": "an ceann {0} latha",
          "two": "an ceann {0} latha"
        },
        "past": {
          "few": "{0} làithean air ais",
          "one": "{0} latha air ais",
          "other": "{0} latha air ais",
          "two": "{0} latha air ais"
        }
      },
      "day-narrow": {
        "-1": "an-dè",
        "-2": "a-bhòin-dè",
        "0": "an-diugh",
        "1": "a-màireach",
        "2": "an-earar",
        "3": "an-eararais",
        "future": {
          "few": "+{0} là",
          "one": "+{0} là",
          "other": "+{0} là",
          "two": "+{0} là"
        },
        "past": {
          "few": "-{0} là",
          "one": "-{0} là",
          "other": "-{0} là",
          "two": "-{0} là"
        }
      },
      "day-short": {
        "-1": "an-dè",
        "-2": "a-bhòin-dè",
        "0": "an-diugh",
        "1": "a-màireach",
        "2": "an-earar",
        "3": "an-eararais",
        "future": {
          "few": "an {0} là.",
          "one": "an {0} là",
          "other": "an {0} là",
          "two": "an {0} là"
        },
        "past": {
          "few": "o {0} là.",
          "one": "o {0} là",
          "other": "o {0} là",
          "two": "o {0} là"
        }
      },
      "hour": {
        "0": "am broinn uair a thìde",
        "future": {
          "few": "an ceann {0} uairean a thìde",
          "one": "an ceann {0} uair a thìde",
          "other": "an ceann {0} uair a thìde",
          "two": "an ceann {0} uair a thìde"
        },
        "past": {
          "few": "{0} uairean a thìde air ais",
          "one": "{0} uair a thìde air ais",
          "other": "{0} uair a thìde air ais",
          "two": "{0} uair a thìde air ais"
        }
      },
      "hour-narrow": {
        "0": "san uair",
        "future": {
          "few": "+{0} u.",
          "one": "+{0} u.",
          "other": "+{0} u.",
          "two": "+{0} u."
        },
        "past": {
          "few": "-{0} u.",
          "one": "-{0} u.",
          "other": "-{0} u.",
          "two": "-{0} u."
        }
      },
      "hour-short": {
        "0": "am broinn uair",
        "future": {
          "few": "an {0} uair.",
          "one": "an {0} uair",
          "other": "an {0} uair",
          "two": "an {0} uair"
        },
        "past": {
          "few": "o {0} uair.",
          "one": "o {0} uair",
          "other": "o {0} uair",
          "two": "o {0} uair"
        }
      },
      "minute": {
        "0": "am broinn mionaid",
        "future": {
          "few": "an ceann {0} mionaidean",
          "one": "an ceann {0} mhionaid",
          "other": "an ceann {0} mionaid",
          "two": "an ceann {0} mhionaid"
        },
        "past": {
          "few": "{0} mionaidean air ais",
          "one": "{0} mhionaid air ais",
          "other": "{0} mionaid air ais",
          "two": "{0} mhionaid air ais"
        }
      },
      "minute-narrow": {
        "0": "sa mhion.",
        "future": {
          "few": "+{0} m",
          "one": "+{0} m",
          "other": "+{0} m",
          "two": "+{0} m"
        },
        "past": {
          "few": "-{0} m",
          "one": "-{0} m",
          "other": "-{0} m",
          "two": "-{0} m"
        }
      },
      "minute-short": {
        "0": "am broinn mion.",
        "future": {
          "few": "an {0} mion.",
          "one": "an {0} mhion.",
          "other": "an {0} mion.",
          "two": "an {0} mhion."
        },
        "past": {
          "few": "o {0} mion.",
          "one": "o {0} mhion.",
          "other": "o {0} mion.",
          "two": "o {0} mhion."
        }
      },
      "month": {
        "-1": "am mìos seo chaidh",
        "0": "am mìos seo",
        "1": "an ath-mhìos",
        "future": {
          "few": "an ceann {0} mìosan",
          "one": "an ceann {0} mhìosa",
          "other": "an ceann {0} mìosa",
          "two": "an ceann {0} mhìosa"
        },
        "past": {
          "few": "{0} mìosan air ais",
          "one": "{0} mhìos air ais",
          "other": "{0} mìos air ais",
          "two": "{0} mhìos air ais"
        }
      },
      "month-narrow": {
        "-1": "mì. ch.",
        "0": "am mì. seo",
        "1": "ath-mhì.",
        "future": {
          "few": "+{0} mì.",
          "one": "+{0} mhì.",
          "other": "+{0} mì.",
          "two": "+{0} mhì."
        },
        "past": {
          "few": "-{0} mì.",
          "one": "-{0} mhì.",
          "other": "-{0} mì.",
          "two": "-{0} mhì."
        }
      },
      "month-short": {
        "-1": "am mìos sa chaidh",
        "0": "am mìos seo",
        "1": "an ath-mhìos",
        "future": {
          "few": "an {0} mìos.",
          "one": "an {0} mhìos.",
          "other": "an {0} mìos.",
          "two": "an {0} mhìos."
        },
        "past": {
          "few": "o {0} mìos.",
          "one": "o {0} mhìos.",
          "other": "o {0} mìos.",
          "two": "o {0} mhìos."
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "an cairteal seo chaidh",
        "0": "an cairteal seo",
        "1": "an ath-chairteal",
        "future": {
          "few": "an ceann {0} cairtealan",
          "one": "an ceann {0} chairteil",
          "other": "an ceann {0} cairteil",
          "two": "an ceann {0} chairteil"
        },
        "past": {
          "few": "{0} cairtealan air ais",
          "one": "{0} chairteal air ais",
          "other": "{0} cairteal air ais",
          "two": "{0} chairteal air ais"
        }
      },
      "quarter-narrow": {
        "-1": "c. ch.",
        "0": "an c. seo",
        "1": "ath-ch.",
        "future": {
          "few": "+{0} c.",
          "one": "+{0} c.",
          "other": "+{0} c.",
          "two": "+{0} c."
        },
        "past": {
          "few": "-{0} c.",
          "one": "-{0} c.",
          "other": "-{0} c.",
          "two": "-{0} c."
        }
      },
      "quarter-short": {
        "-1": "an cairt. sa chaidh",
        "0": "an cairt. seo",
        "1": "an ath-chairt.",
        "future": {
          "few": "an {0} cairt.",
          "one": "an {0} chairt.",
          "other": "an {0} cairt.",
          "two": "an {0} chairt."
        },
        "past": {
          "few": "o {0} cairt.",
          "one": "o {0} chairt.",
          "other": "o {0} cairt.",
          "two": "o {0} chairt."
        }
      },
      "second": {
        "0": "an-dràsta",
        "future": {
          "few": "an ceann {0} diogan",
          "one": "an ceann {0} diog",
          "other": "an ceann {0} diog",
          "two": "an ceann {0} dhiog"
        },
        "past": {
          "few": "{0} diogan air ais",
          "one": "{0} diog air ais",
          "other": "{0} diog air ais",
          "two": "{0} dhiog air ais"
        }
      },
      "second-narrow": {
        "0": "an-dràsta",
        "future": {
          "few": "+{0} d",
          "one": "+{0} d",
          "other": "+{0} d",
          "two": "+{0} d"
        },
        "past": {
          "few": "-{0} d",
          "one": "-{0} d",
          "other": "-{0} d",
          "two": "-{0} d"
        }
      },
      "second-short": {
        "0": "an-dràsta",
        "future": {
          "few": "an {0} diog.",
          "one": "an {0} diog",
          "other": "an {0} diog",
          "two": "an {0} dhiog"
        },
        "past": {
          "few": "o {0} diog.",
          "one": "o {0} diog",
          "other": "o {0} diog",
          "two": "o {0} dhiog"
        }
      },
      "week": {
        "-1": "an t-seachdain seo chaidh",
        "0": "an t-seachdain seo",
        "1": "an ath-sheachdain",
        "future": {
          "few": "an ceann {0} seachdainean",
          "one": "an ceann {0} seachdain",
          "other": "an ceann {0} seachdain",
          "two": "an ceann {0} sheachdain"
        },
        "past": {
          "few": "{0} seachdainean air ais",
          "one": "{0} seachdain air ais",
          "other": "{0} seachdain air ais",
          "two": "{0} sheachdain air ais"
        }
      },
      "week-narrow": {
        "-1": "sn. ch.",
        "0": "an t-sn. seo",
        "1": "ath-shn.",
        "future": {
          "few": "+{0} sn.",
          "one": "+{0} sn.",
          "other": "+{0} sn.",
          "two": "+{0} sn."
        },
        "past": {
          "few": "-{0} sn.",
          "one": "-{0} sn.",
          "other": "-{0} sn.",
          "two": "-{0} sn."
        }
      },
      "week-short": {
        "-1": "seachd. sa chaidh",
        "0": "an t-seachd. seo",
        "1": "an ath-sheachd.",
        "future": {
          "few": "an {0} seachd.",
          "one": "an {0} sheachd.",
          "other": "an {0} seachd.",
          "two": "an {0} sheachd."
        },
        "past": {
          "few": "o {0} seachd.",
          "one": "o {0} sheachd.",
          "other": "o {0} seachd.",
          "two": "o {0} sheachd."
        }
      },
      "year": {
        "-1": "an-uiridh",
        "-2": "a-bhòn-uiridh",
        "0": "am bliadhna",
        "1": "an ath-bhliadhna",
        "future": {
          "few": "an ceann {0} bliadhnaichean",
          "one": "an ceann {0} bhliadhna",
          "other": "an ceann {0} bliadhna",
          "two": "an ceann {0} bhliadhna"
        },
        "past": {
          "few": "{0} bhliadhnaichean air ais",
          "one": "{0} bhliadhna air ais",
          "other": "{0} bliadhna air ais",
          "two": "{0} bhliadhna air ais"
        }
      },
      "year-narrow": {
        "-1": "an-uir.",
        "-2": "a-bh-uir.",
        "0": "am bl.",
        "1": "an ath-bhl.",
        "future": {
          "few": "+{0} bl.",
          "one": "+{0} bhl.",
          "other": "+{0} bl.",
          "two": "+{0} bhl."
        },
        "past": {
          "few": "-{0} bl.",
          "one": "-{0} bhl.",
          "other": "-{0} bl.",
          "two": "-{0} bhl."
        }
      },
      "year-short": {
        "-1": "an-uiridh",
        "-2": "a-bhòn-uiridh",
        "0": "am bliadhna",
        "1": "an ath-bhliadhna",
        "future": {
          "few": "an {0} blia.",
          "one": "an {0} bhlia.",
          "other": "an {0} blia.",
          "two": "an {0} bhlia."
        },
        "past": {
          "few": "o {0} blia.",
          "one": "o {0} bhlia.",
          "other": "o {0} blia.",
          "two": "o {0} bhlia."
        }
      }
    },
    "locale": "gd"
  });
}